export const environment = {
  production: false,
  apiUrl: 'https://qaapi.concursonacionaldeventas.com',
  oktaConfig: {
    issuer: 'https://secure.ite.pepsico.com/oauth2/default',
    clientId: '0oa2nj09q0eS3a8Sz0h8',
    allowedOrigins: [
      'https://localhost',
      'https://qaapi.concursonacionaldeventas.com',
    ],
  },
  siteKey: '0x4AAAAAACFgXlf4KBWr_8C6',
  isScanning: false,
  redirectAdmin: 'https://mlgdev.mx/AdminCNV/home',
  redirectRascaGana: 'https://mlgdev.mx/RyG',
  redirectMaraton: 'https://qamaratondecompras.concursonacionaldeventas.com',
  appInsightsConnectionString: "InstrumentationKey=3d110234-ffce-421c-90d8-f315540118c6;IngestionEndpoint=https://southcentralus-3.in.applicationinsights.azure.com/;LiveEndpoint=https://southcentralus.livediagnostics.monitor.azure.com/;ApplicationId=e9723290-632f-48c0-9c59-e229bd91ddf7"
};
